import logger from '@/utils/logger'
import RepaymentApi from '@/api/repayment'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  async getKnetPaymentStatus({ dispatch }, dataToBeSent) {
    try {
      const result = await RepaymentApi.getKnetPaymentStatus(dataToBeSent)
      const message = result?.data?.message

      if (message) {
        dispatch('checkout/setCheckoutFailedMessage', message, { root: true })
      }
    } catch (error) {
      logger.error(error, {
        component: 'repayment',
        action: 'getKnetPaymentStatus',
      })
    }
  },
}

export default { namespaced: true, state, getters, mutations, actions }
